import { TFunction } from 'i18next'
import { DataItem } from 'scrivito'

import { MenuItemProps } from '@/Atomic/Molecules/MenuItem'
import { DataClassName } from '@/Data/const'
import { isAutomationsItem } from '@/utils/automationsUtils'
import { getDataClassIcon } from '@/utils/image'

interface Options {
  dataItem: DataItem
  t: TFunction<'translation', undefined>
  omitSidebar?: boolean
  onNavigateToClick: (e: React.MouseEvent) => void
  onOpenInNewTabClick: () => void
  onOpenEntityCanvasClick: (e: React.MouseEvent, startInEdit?: boolean) => void
  openDeleteModal: () => void
}

export const getRowMenu = ({
  dataItem,
  t,
  omitSidebar,
  onNavigateToClick,
  onOpenInNewTabClick,
  onOpenEntityCanvasClick,
  openDeleteModal,
}: Options) => {
  const actions: MenuItemProps[] = []
  const dataClassName = dataItem.dataClassName()!
  const automationsItem = isAutomationsItem(dataItem)

  if (!omitSidebar && !automationsItem) {
    actions.push({
      icon: 'info-circle',
      label: t('common.seeDetails'),
      onClick: (e: React.MouseEvent) => {
        onOpenEntityCanvasClick(e)
      },
    })
  }

  actions.push({
    icon: 'link-external',
    label: t('common.openInNewTab'),
    onClick: () => {
      onOpenInNewTabClick()
    },
  })

  if (!omitSidebar && !automationsItem) {
    actions.push({
      icon: 'edit',
      label: t('common.edit'),
      onClick: (e: React.MouseEvent) => {
        onOpenEntityCanvasClick(e, true)
      },
    })
  }

  actions.push({
    icon: automationsItem
      ? 'email-opened'
      : getGoToDetailsPageIcon(dataClassName),
    label: t(
      automationsItem
        ? 'common.goToAutomations'
        : getGoToDetailsPageLabelKey(dataClassName),
    ),
    onClick: (e: React.MouseEvent) => {
      onNavigateToClick(e)
    },
  })

  if (!omitSidebar) {
    actions.push({
      icon: 'bin',
      label: t('common.delete'),
      type: 'danger' as const,
      onClick: () => {
        openDeleteModal()
      },
    })
  }

  return actions
}

const getGoToDetailsPageIcon = (dataClassName: string) => {
  switch (dataClassName) {
    case DataClassName.MY_WORK_CONTACT_RELATION:
      return 'person'
    case DataClassName.GLOBAL_RESULT:
      return 'document-text'
    default:
      return getDataClassIcon(dataClassName)
  }
}

const getGoToDetailsPageLabelKey = (dataClassName: string) => {
  switch (dataClassName) {
    case DataClassName.ACTIVITY:
      return 'common.goToDetailsPage.activity'
    case DataClassName.COMPANY:
      return 'common.goToDetailsPage.company'
    case DataClassName.CONTACT:
    case DataClassName.MY_WORK_CONTACT_RELATION:
      return 'common.goToDetailsPage.contact'
    case DataClassName.DOCUMENT:
      return 'common.goToDetailsPage.document'
    case DataClassName.GLOBAL_RESULT:
      return 'common.goToDetailsPage.globalResult'
    case DataClassName.LEAD:
      return 'common.goToDetailsPage.lead'
    case DataClassName.LIST:
      return 'common.goToDetailsPage.segment'
    case DataClassName.OPPORTUNITY:
      return 'common.goToDetailsPage.opportunity'
    case DataClassName.ORDER:
      return 'common.goToDetailsPage.order'
    case DataClassName.PERSON:
      return 'common.goToDetailsPage.person'
    case DataClassName.QUOTE:
      return 'common.goToDetailsPage.quote'
    case DataClassName.TICKET:
      return 'common.goToDetailsPage.ticket'
    default:
      return 'common.goToDetailsPage.default'
  }
}
